function e(e=this.params.speed,t=!0,s){return this.slideTo(this.activeIndex,e,t,s)}export{e as default};
//# sourceMappingURL=slideReset.js.map
